import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UserSessionService } from 'bna-angular-auth-client';
import { OrganizationService } from 'src/app/core/services/http/agency-mgmt/organization.service';
import { SettingsService } from 'src/app/core/services/http/agency-mgmt/settings.service';
import { TosterService } from 'src/app/core/services/toster/toster.service';
import { OrganizationResult } from 'src/app/shared/models/agency-mgmt/manager.service.model';

@Component({
  selector: 'app-switch-organization',
  templateUrl: './switch-oganization.component.html',
  styleUrls: ['./switch-oganization.component.scss'],
})
export class SwitchOrganizationComponent implements OnInit {
  organizations: OrganizationResult[] = [];
  modalPopup = false;
  switching = false;
  private selectedOrganizationId: string;

  constructor(
    private toasterService: TosterService,
    private organizationService: OrganizationService,
    private userSessionService: UserSessionService,
    @Inject(MAT_DIALOG_DATA) public modalData: { modalPopup: boolean },
    public dialogRef: MatDialogRef<SwitchOrganizationComponent>,
    private settingsService: SettingsService
  ) {
    if (this.modalData) this.modalPopup = modalData.modalPopup;
  }

  ngOnInit() {
    this.organizationService.getList().subscribe((organizations) => {
      if (organizations?.length < 2) return;
      this.organizations = organizations;
    });

    this.userSessionService.isAuthenticated$.subscribe((result) => {
      if (!result.isAuthenticated) return;
      this.selectedOrganizationId =
        this.userSessionService.getProfile().organizationId;
    });
  }

  switch(id: string) {
    this.switching = true;
    this.userSessionService.switchOrganization(id).subscribe((_) => {
      this.closeDialog();
      this.settingsService.generalSettings$=null;
      this.switching = false;
      this.toasterService.success('Organization switched');
    });
  }

  private closeDialog() {
    if (!this.modalData?.modalPopup) return;
    this.dialogRef.close();
  }

  public isCurrentOrganization(org: OrganizationResult) {
    return this.selectedOrganizationId == org.id;
  }
}
